import React from 'react';
import { Outlet } from 'react-router-dom';

const Index = () => {
    return (
        <Outlet/>
    );
}

export default Index;
